export const T = {
  en_GB: {
    url: "Web page URL",
    placeholder: "https://www.youtube.com/embed/…",
    helpText:
      "Absolute https:// address of the page, video or form. The site must allow being embedded — check the preview below.",
    urlInvalid: "Must be an absolute https:// address without credentials",
    urlAppOrigin: "This URL points to the app itself and cannot be shown here",
    size: "Size",
    fixedHeight: "Fixed height",
    ratio169: "16:9 (video)",
    ratio43: "4:3",
    ratio11: "1:1",
    heightPx: "Height (px)",
    previewCaption: "Preview — blank means the site refuses to be embedded",
  },
  nb_NO: {
    url: "Nettside-URL",
    placeholder: "https://www.youtube.com/embed/…",
    helpText:
      "Absolutt https://-adresse til siden, videoen eller skjemaet. Nettstedet må tillate innbygging – sjekk forhåndsvisningen under.",
    urlInvalid: "Må være en absolutt https://-adresse uten brukernavn/passord",
    urlAppOrigin: "Denne adressen peker til selve appen og kan ikke vises her",
    size: "Størrelse",
    fixedHeight: "Fast høyde",
    ratio169: "16:9 (video)",
    ratio43: "4:3",
    ratio11: "1:1",
    heightPx: "Høyde (px)",
    previewCaption: "Forhåndsvisning – tomt betyr at nettstedet nekter innbygging",
  },
} as const;
